import React from 'react'

import Base from '../_Base'

const More = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M6 8c.55 0 1-.9 1-2s-.45-2-1-2-1 .9-1 2 .45 2 1 2zm-1 4c0 1.1.45 2 1 2s1-.9 1-2-.45-2-1-2-1 .9-1 2zm1 4c-.55 0-1 .9-1 2s.45 2 1 2 1-.9 1-2-.45-2-1-2z"
      fillRule="evenodd"
    />
  </Base>
)

export default More
